import { UploadFile } from "@king-ict/eupisi-ui/models";

import { MzomAppeal } from "../../../models/Request";
import { Attachment } from "../../../models/Shared/Attachment";
import { MAX_MZOM_APPEAL_FILES } from "./constants";
import { appendToExistingAppeal, canAddMzomAppealDocument } from "./utils";

interface IParams {
  appeal: MzomAppeal;
  setShowUploadModal: (isOpen: boolean) => void;
  handleUpdate: (value: MzomAppeal) => void;
}

export function useMzomAppealFiles({
  appeal,
  setShowUploadModal,
  handleUpdate,
}: IParams) {
  const appendToExistingAppealForCurrentAppeal = appendToExistingAppeal(appeal);

  // DocumentsModal ignores the filesAction prop and base64-encodes the files
  // itself, returning them through onConfirm (handleUploadFileChange).
  const handleFileChange = () => {};

  const handleUploadFileChange = (files: UploadFile[]) => {
    if (!canAddMzomAppealDocument(appeal)) {
      setShowUploadModal(false);
      return;
    }

    const remainingSlots =
      MAX_MZOM_APPEAL_FILES -
      (appeal.attachments?.length ?? 0) -
      (appeal.uploadFiles?.length ?? 0);

    const filesToAdd = files.slice(0, Math.max(remainingSlots, 0));
    const combinedFiles = filesToAdd.concat(appeal.uploadFiles ?? []);
    const updatedAppeal = appendToExistingAppealForCurrentAppeal(
      combinedFiles,
      "uploadFiles"
    );

    setShowUploadModal(false);
    handleUpdate(updatedAppeal);
  };

  const handleRemoveAttachment = (attachment: Attachment) => {
    if (!attachment?.id) {
      return;
    }

    const attachments = appeal.attachments?.filter(
      (item) => item.id !== attachment.id
    );
    const updatedAppeal = appendToExistingAppealForCurrentAppeal(
      attachments ?? [],
      "attachments"
    );

    handleUpdate(updatedAppeal);
  };

  const handleRemoveUploadFile = (uploadFile: UploadFile) => {
    if (!uploadFile?.fileName) {
      return;
    }

    const uploadFiles = appeal.uploadFiles?.filter(
      (item) => item.fileName !== uploadFile.fileName
    );
    const updatedAppeal = appendToExistingAppealForCurrentAppeal(
      uploadFiles ?? [],
      "uploadFiles"
    );

    handleUpdate(updatedAppeal);
  };

  return {
    handleFileChange,
    handleUploadFileChange,
    handleRemoveAttachment,
    handleRemoveUploadFile,
  };
}
